<template>
  <div class="goods1">
    <div class="mb20">点击按钮进行配置。二维码像素推荐200*200像素</div>
    <el-form :model="currentInfo" label-width="80px">
      <el-form-item label="二维码">
        <el-upload
          :action="fileObj.url"
          :before-upload="beforeUpload"
          :on-success="successUpdate"
          :headers="reqData"
          :show-file-list="false"
        >
          <img
            class="list-img"
            v-if="currentInfo.picture"
            :src="currentInfo.picture"
            @click="updateImg()"
          />
          <i class="el-icon-plus" v-else />
        </el-upload>
      </el-form-item>
      <el-form-item label="电话">
        <el-input placeholder="请输入电话" v-model="currentInfo.title" />
      </el-form-item>
      <el-button type="primary" @click="settingBtn('关于我们', 0)"
        >关于我们配置</el-button
      >
      <el-button type="primary" @click="settingBtn('发展历程', 1)"
        >发展历程配置</el-button
      >
      <el-button type="primary" @click="settingBtn('荣誉资质', 2)"
        >荣誉资质配置</el-button
      >
    </el-form>
    <UE-dialog
      ref="UEDialog"
      :title="dialogTitle"
      :content="content"
      @addUEBtn="addUEBtn"
    />
  </div>
</template>
<script>
import { codeMixin } from "../../../minix";
import UEDialog from "../../components/UEDialog.vue";
export default {
  mixins: [codeMixin],
  components: { UEDialog },
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "",
      content: "",
      dialogIndex: 0,
    };
  },
  methods: {
    settingBtn(val, index) {
      this.$refs.UEDialog.dialogVisible = true;
      this.dialogTitle = val;
      this.dialogIndex = index;
      this.content = this.currentInfo.wxSchoolPageItemList[index].content;
    },
    addBannerBtn() {
      this.currentInfo.wxSchoolPageItemList.push({
        type: this.currentInfo.type,
        content: "",
      });
    },
    addUEBtn(val) {
      this.currentInfo.wxSchoolPageItemList[this.dialogIndex].content = val;
    },
  },
  mounted() {
    if (
      !this.currentInfo.wxSchoolPageItemList ||
      this.currentInfo.wxSchoolPageItemList.length == 0
    ) {
      this.addBannerBtn();
      this.addBannerBtn();
      this.addBannerBtn();
    }
  },
};
</script>
<style lang="less" scoped>
.goods1 {
  /deep/ .el-upload {
    width: 100px;
    height: 100px;
    border: 1px dashed rgb(196, 192, 192);
    display: flex;
    border-radius: 6px;
    align-items: center;
    justify-content: center;
    .el-icon-plus {
      font-size: 36px;
    }
    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
    }
  }
  .jc-sb {
    width: 100%;
    padding: 10px;
    box-sizing: border-box;
    margin-top: 10px;
    border-radius: 6px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/designPage/template/module/module2/setting.vue